export default __webpack_public_path__ + "static/media/Scheda_finca_Test_bench.01cf0d1e.pdf";